import React, { ReactElement, ReactNode } from 'react';

import { ErrorBoundary } from 'react-error-boundary';
import { useQueryErrorResetBoundary } from 'react-query';

import ContentsErrorFallback from './ContentsErrorFallback';

interface Props {
    children: ReactNode | ReactElement;
}

const ContentsErrorBoundary = ({ children }: Props) => {
    const { reset } = useQueryErrorResetBoundary();

    return (
        <ErrorBoundary
            onReset={reset}
            FallbackComponent={ContentsErrorFallback}
        >
            {children}
        </ErrorBoundary>
    );
};

export default ContentsErrorBoundary;
